import axios from "axios"
import { baseUrlApi } from "./Api.js"
import Csrf from "./Csrf.js"

export default {

  getCountries() {
    const url = `${baseUrlApi}/countries`;
    return axios.get(url);
  },

  getStates() {
    const url = `${baseUrlApi}/states`;
    return axios.get(url);
  },

  postCities(stateId) {
    const url = `${baseUrlApi}/post-cities-id`;
    return axios.post(url, stateId);
  },
};

